function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/home/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'home')
    }
}

let routes = [
    {
        name: 'emsHome',
        path: '/ems/home',
        meta: {
            title: '领筑云'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/home.js